import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(auth)/(main-layout)/profile/$profileId/')({
  loader: ({ params }) => {
    throw redirect({ to: `/profile/${params.profileId}/about`, statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
